import React from 'react';
import { Link } from 'react-router-dom';

import Logo from '../../images/lhcf_logo.jpeg';
import './style.css';

const Footer = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <footer className="wpo-site-footer pt-5">
      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <img src={Logo} alt="" />
                </div>
                <p>
                  Charity organization for street, orphaned, and vulnerable
                  children
                </p>
                <ul>
                  <li>
                    <a
                      href="https://www.facebook.com/profile.php?id=100069380533889"
                      target={'_blank'}
                      rel="noopener noreferrer"
                    >
                      <i className="ti-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/lovehopeandcarefoundation/"
                      target={'_blank'}
                      rel="noopener noreferrer"
                    >
                      <i className="ti-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/lovehope-andcarefoundation-9a0a10214/ "
                      target={'_blank'}
                      rel="noopener noreferrer"
                    >
                      <i className="ti-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/channel/UCmOuCJpd1XRYEBJ635wj6xw"
                      target={'_blank'}
                      rel="noopener noreferrer"
                    >
                      <i className="ti-youtube"></i>
                    </a>
                  </li>
                  {/* TODO: CONSIDER ADDING TWITTER AS WELL */}
                </ul>
              </div>
            </div>
            <div className="col col-lg-2 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Useful Links</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/about">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/publications">
                      Our Publications
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/events">
                      Our Events
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/blog">
                      Our Blog
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-4 offset-lg-1 col-md-6 col-sm-12 col-12">
              <div className="widget market-widget wpo-service-link-widget">
                <div className="widget-title">
                  <h3>Contact </h3>
                </div>
                <div className="contact-ft">
                  <ul>
                    {/* <li>
                      <i className="fi flaticon-call"></i>+1 (604) 445-9066,
                      +250 784 089 536
                    </li> */}
                    <li>
                      <i className="fi flaticon-pin"></i>Vancouver, Canada &
                      Kigali, Rwanda
                    </li>
                    <li>
                      <i className="fi flaticon-envelope"></i>
                      info@lovehopeandcarefoundation.org
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <p className="copyright">
                &copy; {new Date().getFullYear()} Love Hope and Care Foundation.
                All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
